import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

    constructor(
        private authService: AuthService,
    ) { }

    /**
     * Adds authorization header to HTTP request.
     * @param request The outgoing request object to handle.
     * @param next The next interceptor in the chain, or the backend.
     */
    intercept(request: HttpRequest<any>, next: HttpHandler) {
        const token: string = this.authService.getToken();

        if (token && request.url.indexOf(environment.apiUrl) === 0) {
            return next.handle(request.clone({
                headers: request.headers.set('Authorization', `Token ${token}`)
            }));
        }

        return next.handle(request);
    }
}
